import React from 'react'

const Restaurant = ({ menuData }) => {
    const ht = { height: '220px', objectFit: 'cover' }
    return (
        <div className="d-flex flex-wrap card-wrap">
            {
                menuData.map(e => {
                    return <div className="card mb-4" key={e.id}>
                        <img src={e.image} className="card-img-top" alt={e.title} style={ht} />
                        <div className="card-body">
                            <p className="fw-bold text-primary"><span>Id: {e.id}, </span> <span>Category: {e.category}</span></p>
                            <h2 className="card-title">{e.title}</h2>
                            <p className="card-text">{e.description}</p>
                            <button className="btn btn-primary">Read More..</button>
                        </div>
                    </div>
                })
            }

        </div>
    )
}

export default Restaurant
